export const environment = {
  production: false,
  // apiBaseUrl: 'https://localhost:7127/api',
  apiBaseUrl: 'https://dev-api.hospitalease.in/api',
};
